import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { apiGet, ApiError } from "../lib/api";

export default function Verify() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState<"loading" | "ok" | "error">("loading");
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMessage("Token chybí v URL.");
      return;
    }
    apiGet(`/api/verify?token=${encodeURIComponent(token)}`)
      .then(() => setState("ok"))
      .catch((err) => {
        setState("error");
        setMessage(err instanceof ApiError ? err.message : "Ověření se nezdařilo.");
      });
  }, [token]);

  return (
    <div className="container">
      <div className="card">
        {state === "loading" && <p>Ověřuji…</p>}
        {state === "ok" && (
          <>
            <h1>Email ověřen</h1>
            <p>Vaše registrace je dokončena. Děkujeme!</p>
          </>
        )}
        {state === "error" && (
          <>
            <h1>Ověření selhalo</h1>
            <div className="alert alert-error">{message}</div>
            <Link to="/register">Zpět na registraci</Link>
          </>
        )}
      </div>
    </div>
  );
}
